import cn from 'clsx';
import { FC } from 'react';

import s from './BasicList.module.scss';
import BasicListItem, { BasicListItemProps } from './Item/BasicListItem';

export interface BasicListProps extends BasicListItemProps {
  className?: string;
  onClick?: () => void;
}

const BasicList: FC<React.PropsWithChildren<React.PropsWithChildren<BasicListProps>>> = ({ className, onClick, right, listIcon, ...props }) => {
  // TODO: tailwind.config.js에서 page padding 설정하고 page padding 사용하는 곳에 적용
  const canAllAreaClick =
    !right || right?.type === 'checkmark' || right?.type === 'checkbox' || right?.type === 'radio' || right?.type === 'expand' || listIcon;
  const handleClickList = () => {
    if (canAllAreaClick && onClick) {
      onClick();
    }
  };

  return (
    <div
      className={cn(
        s.wrapper,
        {
          [s.press as string]: canAllAreaClick && onClick
        },
        className
      )}
      onClick={handleClickList}
    >
      <BasicListItem right={right} listIcon={listIcon} {...props} />
    </div>
  );
};

export default BasicList;
